import ExamImage from "../components/ExamImage";
import QuestionLayout from "./QuestionLayout";

export default function MultipleChoiceWidget({
  config,
  value,
  onChange,
  mode = "edit",
  feedback
}) {
  const { options } = config;

  const correctId =
    mode === "review" ? feedback?.parts?.[0]?.expected : null;

  function selectOption(id) {
    if (mode !== "edit") return;
    onChange(id);
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
          gap: 16
        }}
      >
        {options.map(opt => {
          const selected = value === opt.id;

          const isCorrect = mode === "review" && opt.id === correctId;
          const isIncorrect =
            mode === "review" &&
            selected &&
            opt.id !== correctId;

          let border = "1px solid #ccc";
          let background = "white";

          if (mode === "review" && isCorrect) {
            border = "2px solid #16a34a";        // green
            background = "#dcfce7";
          } else if (mode === "review" && isIncorrect) {
            border = "2px solid #dc2626";        // red
            background = "#fee2e2";
          } else if (selected) {
            border = "2px solid #2563eb";        // blue (edit mode)
            background = "#eef2ff";
          }

          return (
            <div
              key={opt.id}
              onClick={() => selectOption(opt.id)}
              style={{
                border,
                background,
                borderRadius: 6,
                padding: 10,
                cursor: mode === "edit" ? "pointer" : "default",
                textAlign: "center"
              }}
            >
              {/* LABEL */}
              {opt.label && (
                <div
                  style={{
                    fontWeight: 600,
                    marginBottom: 6
                  }}
                >
                  {opt.label}
                </div>
              )}

              {/* IMAGE OPTION */}
              {opt.image && (
                <ExamImage
                  src={opt.image}
                  alt=""
                  style={{
                    width: "auto",
                    height: "150px",
                    pointerEvents: "none"
                  }}
                />
              )}

              {/* TEXT OPTION */}
              {opt.text && (
                <div style={{ pointerEvents: "none" }}>
                  {opt.text}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </QuestionLayout>
  );
}
